import { ScrollReveal } from './scroll-reveal'

const PAIN_POINTS = [
  'Procurando o arquivo que foi parar em algum lugar entre o Drive, o e-mail e o WhatsApp…',
  'Refazendo na planilha, toda segunda, o que foi planejado e o que foi entregue na semana…',
  'Tentando lembrar o que ficou combinado com o cliente na última visita à obra…',
]

/** Problem statement, a big serif heading over three muted pain points. */
export const ProblemSection = () => (
  <section className="bg-white py-28">
    <div className="mx-auto max-w-[1120px] px-6">
      <ScrollReveal>
        <h2 className="max-w-[920px] font-display text-[#0b0b0d] text-[clamp(32px,4.6vw,48px)] leading-[1.08] tracking-[-0.01em]">
          Boa parte do seu dia vai para gerenciar ferramentas, não projetos
        </h2>
      </ScrollReveal>
      <div className="mt-10 space-y-4">
        {PAIN_POINTS.map((point, index) => (
          <ScrollReveal delay={index * 90} key={point}>
            <p className="text-[#6c6c72] text-[clamp(17px,2.4vw,24px)]">{point}</p>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
)
